var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDependency, useLucidSdk } from '#context';
import { CurrentMemberKeyFactory, WorkspacesKeyFactory, } from '../../query-key-factories';
export const useWorkspaceLeave = (workspaceId, { onError, onSuccess } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const queryClient = useQueryClient();
    const { mutation: { mutateAsync: fullFilespaceLogout }, } = useDependency('useFilespaceQuit')();
    const mutation = useMutation({
        mutationFn: async () => {
            const filespacesToLeave = await lucidSdk
                .workspaceClient(workspaceId)
                .listFilespaces();
            await Promise.all(filespacesToLeave.map(async ({ id, name, workspaceId }) => {
                await fullFilespaceLogout({
                    workspaceId,
                    filespaceId: id,
                    filespaceName: name,
                });
            }));
            await lucidSdk.workspaceClient(workspaceId).leaveWorkspace();
        },
        onSuccess: async () => {
            try {
                // Update list of workspaces
                await Promise.all([
                    queryClient.refetchQueries({
                        exact: true,
                        queryKey: WorkspacesKeyFactory.all(),
                    }),
                    queryClient.refetchQueries({
                        exact: true,
                        queryKey: CurrentMemberKeyFactory.byWorkspace(workspaceId),
                    }),
                ]);
            }
            finally {
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
            }
        },
        onError: (error) => {
            if (typeof onError === 'function') {
                onError(error);
            }
        },
        networkMode: 'always',
    });
    return { mutation };
};
_react_refresh_temp_1(useWorkspaceLeave, "M0XP5yS2MdPkCBnwnsddfgvGc5k=", false, () => [useLucidSdk, useQueryClient, useDependency, useMutation]);
